'use client'

import { useState } from 'react'

import { cn } from '@/core/utils/common'
import SafeImage from '@/features/veluvit/components/ui/media-image'

export default function WorkTitleOverlay({
  src,
  sizes = '240px',
  inset = false,
  className,
}: {
  src?: string
  sizes?: string
  inset?: boolean
  className?: string
}) {
  const [failedSource, setFailedSource] = useState<string | null>(null)
  const source = src?.trim()
  if (!source || failedSource === source) return null
  return (
    <span
      aria-hidden="true"
      data-work-title-overlay
      className={cn(
        'pointer-events-none absolute z-[1]',
        inset
          ? 'inset-0'
          : 'inset-x-[8%] aspect-[3/1] [bottom:var(--work-title-bottom,16%)]',
        className
      )}
    >
      <SafeImage
        src={source}
        alt=""
        fill
        unoptimized
        sizes={sizes}
        appearance="plain"
        className="object-contain object-center drop-shadow-[0_2px_8px_rgb(0_0_0/0.65)]"
        onError={() => setFailedSource(source)}
      />
    </span>
  )
}
